import ActivityMessage from './ActivityMessage';

export default ActivityMessage;
